const cn = {
    home: {
        loading:"拼命加載中",
        contact_one:"RPA專家指導",
        contact_two:"(微信同號)",
        call_number:"178-5702-6974",
        last_update:"最後更新時間：",
    },
    topBar: {
        searchPlaceholder:"請輸入搜索關鍵字",
        helpCenter:"幫助中心",
        detail:"無需複雜編程，輕鬆實現自動化流程",
    },
    word:{
        tip:"提示",
        confirm:"確定",
        cancel:"取消",
        setting:"設置",
        save:"保存",
    },
    api: {
        requestError:"請求錯誤"
    }
}

export default cn;
